import { Model, View } from '@lernetz/ts-lib';

import linkedVideoTemplate from './LinkedVideo.html';


export class LinkedVideo extends Model {

    public readonly alt?: string;
    public readonly description: string;
    public readonly marginTop: string;
    public readonly marginBottom: string;
    public readonly type: string;
    public url: string;

    constructor(dto) {
        super({
            alt: '',
            description: '',
            marginTop: '',
            marginBottom: '',
            type: 'Youtube',
            url: '',
            ...dto
        });

        this.patchUrl();
    }

    /**
     * Rewrites incorrect URLs so we have a valid embed URL.
     */
    private patchUrl() {
        // TODO: This could be improved a lot, but it should do for now.

        switch (this.type) {
            case 'YouTube': {
                const videoId = /https\:\/\/youtu\.be\/([^\?]+)(\?.+)?/;
                const match = this.url.match(videoId);
                if (match) {
                    this.url = `https://www.youtube-nocookie.com/embed/${match[1]}${match[2]}`;
                }
                break;
            }
        }
    }
}


export class LinkedVideoView extends View<LinkedVideo> {

    constructor() {
        super({ template: linkedVideoTemplate });
    }

    init() {
        const hasDescription = this.data.description && this.data.description !== '<p></p>';
        if (hasDescription) {
            this.node.querySelector('[js="description"]').innerHTML = this.data.description;
            this.node.querySelector('.caption').classList.remove('-hidden');
        }
    }
}
